import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
import { DataGrid, GridToolbar } from '@mui/x-data-grid';
import { Link } from 'react-router-dom';
import Swal from 'sweetalert2';
import Select from 'react-select';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import {baseUrl, userLocation, ipAddress, userName} from '../Univ.js'

function TicketResponse(){
  const [Tickview, setTickView] = useState([]);
  const [ViewTickData, setViewTickData] = useState([]);
  const [tickRes, setTickRes] = useState([]);
  const [user, setUser] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [selectedDate, setSelectedDate] = useState(new Date());
  const [selectedEscDate, setSelectedEscDate] = useState(new Date());
  const [ticketCreateIds, setTicketCreateIds] = useState([]);
  const [ticketResponseIds, setTicketResponseIds] = useState([]);

  const [TickData,setTickData]=useState({
        "ticket":'',
        "reply":'',
        "assign_to":'',
        "resolve_status":'',
        "addedby":'',
        "ip_add":'',
    });
  const [ResTickData,setResTickData]=useState({
        "reply":'',
        "resolve_status":'',
        "resolve_on":'',
        "addedby":'',
        "ip_add":'',
  });
  const [EscTickData,setEscTickData]=useState({
        "escl_action":'',
        "escl_to":'',
        "escl_status":'',
        "escl_on":'',
        "escl_type":'',
        "addedby":'',
        "ip_add":'',
  });
  useEffect(() => {
    fetchData();
    fetchTickData();
    fetchViewTickData();
  }, []);

  function fetchData() {
    axios.get(baseUrl + "user-search/")
      .then(response => {
        setUser(response.data);
      })
      .catch(error => {
        console.log(error);
      });
  }

  function fetchTickData() {
    axios.get(baseUrl + "ticket-create/")
      .then(response => {
        setTickView(response.data);
        setTicketCreateIds(response.data.map(item => item.id));
      })
      .catch(error => {
        console.log(error);
      });
  }
  function fetchViewTickData() {
    axios.get(baseUrl + "ticket-response/")
      .then(response => {
        setViewTickData(response.data);
        setTicketResponseIds(response.data.map(item => item.ticket.id));
      })
      .catch(error => {
        console.log(error);
      });
  }

  const columns = [
    { field: 'ticket', headerName: 'Ticket ID', width: 130 },
    { field: 'add_date', headerName: 'Raised On', width: 120 },
    { field: 'addedby', headerName: 'Raised By', width: 130},
    { field: 'subject', headerName: 'Subject', width: 120},
    { field: 'reason', headerName: 'Reason', width: 170 },
    { field: 'priority', headerName: 'Priority', width: 120,
    renderCell: (params) => {
      const priority = params.value;
      return (
        <>
          {priority === 'Low' && (
            <span className="badge bg-info">Raised</span>
          )}
          {priority === 'Normal' && (
            <span className="badge bg-primary">{priority}</span>
          )}
          {priority === 'High' && (
            <span className="badge bg-danger">{priority}</span>
          )}
        </>
      );
    },
    },
    { field: 'open_status', headerName: 'Status', width: 120,
    renderCell: (params) => {
      const open_status = params.value;
      return (
        <>
          {open_status === 0 && (
            <span className="badge bg-info">Raised</span>
          )}
          {open_status === 1 && (
            <span className="badge bg-primary">Open</span>
          )}
          {open_status === 2 && (
            <span className="badge bg-warning">InProgress</span>
          )}
          {open_status === 3 && (
            <span className="badge bg-success">Answered</span>
          )}
          {open_status === 4 && (
            <span className="badge bg-danger">Reopened</span>
          )}
          {open_status === 5 && (
            <span className="badge bg-dark">Closed</span>
          )}
        </>
      );
    },
    },
    { field: 'view', headerName: 'View',
        renderCell: (params) => {
        const open_status = params.row.open_status;
        const ticketId = params.row.id;
        if (ticketCreateIds.includes(ticketId) && open_status === 0) {
           return (
            <button
              type="button"
              className="btn btn-success"
              data-bs-toggle="modal"
              data-bs-target="#response-modal"
              onClick={() => handleTickClick(ticketId)}
            >
              View
            </button>
           );
        } else if (ticketResponseIds.includes(ticketId) && open_status > 0 ) {
            return (
            <button
              type="button"
              className="btn btn-primary"
              data-bs-toggle="modal"
              data-bs-target="#response-update-modal"
              onClick={() => handleRespClick(ticketId)}
            >
              Update
            </button>
           );
          }
            return null; // Handle other cases
      },
      width: 120 },
      { field: 'escalate', headerName: 'Escalate',
        renderCell: (params) => {
        const open_status = params.row.open_status;
        const ticketId = params.row.id;
        if (ticketResponseIds.includes(ticketId) && open_status > 2 ) {
            return (
            <button
              type="button"
              className="btn btn-danger"
              data-bs-toggle="modal"
              data-bs-target="#response-esc-modal"
              onClick={() => handleEscClick(ticketId)}
            >
              Escalate
            </button>
           );
          }
            return null; // Handle other cases
      },
      width: 130 },
  ];
const handleTickClick = (ticketId) => {
  const selectedData = Tickview.find(data => data.id == ticketId);
  if (selectedData) {
    setTickRes({
      tid: selectedData.id,
      ticket: selectedData.ticket,
      asset: selectedData.equipment.product,
      priority: selectedData.priority,
      subject: selectedData.subject,
      reason: selectedData.reason,
    });
  }
};
const handleRespClick = (ticketId) => {
  const selectedData = ViewTickData.find(data => data.ticket.id == ticketId);
  if (selectedData) {
    setResTickData({
      resid: selectedData.id,
      tkid: selectedData.ticket.id,
      ticket: selectedData.ticket.ticket,
      asset: selectedData.ticket.equipment.product,
      priority: selectedData.ticket.priority,
      subject: selectedData.ticket.subject,
      reason: selectedData.ticket.reason,
      reply: selectedData.reply,
      resolve_status: selectedData.resolve_status,
    });
  }
};
const handleEscClick = (ticketId) => {
  const selectedEscData = ViewTickData.find(data => data.ticket.id == ticketId);
  if (selectedEscData) {
    setEscTickData({
      rid: selectedEscData.id,
      etid: selectedEscData.ticket.id,
      ticket: selectedEscData.ticket.ticket,
      asset: selectedEscData.ticket.equipment.product,
      priority: selectedEscData.ticket.priority,
      subject: selectedEscData.ticket.subject,
      reason: selectedEscData.ticket.reason,
      reply: selectedEscData.reply,
      resolve_status: selectedEscData.resolve_status,
      resolve_on: selectedEscData.resolve_on,
      escl_action: selectedEscData.escl_action,
      escl_status: selectedEscData.escl_status,
      escl_on: selectedEscData.escl_on,
      escl_to: selectedEscData.escl_to,
      escl_type: selectedEscData.escl_type,

    });
  }
};

  const handleTickChange = (event) => {
        setTickData({
            ...TickData,
            [event.target.name]:event.target.value
        });
  };

const handleRespChange = (event) => {
  const selectedValue = event.target.value;
  setResTickData((prevData) => ({
    ...prevData,
    resolve_status: selectedValue,
  }));
};
const handleRespChangeTextarea = (event) => {
  const newValue = event.target.value;
  setResTickData((prevData) => ({
    ...prevData,
    reply: newValue,
  }));
};

const handleDateChange = (date) => {
    if (date) {
        const dateString = date.toISOString().slice(0,10);
        const dateObj = new Date(dateString);
        dateObj.setHours(0, 0, 0, 0);
        setSelectedDate(dateObj);
    }
};
const handleEscDateChange = (date) => {
    if (date) {
        const dateString = date.toISOString().slice(0,10);
        const dateObj = new Date(dateString);
        dateObj.setHours(0, 0, 0, 0);
        setSelectedEscDate(dateObj);
    }
};
const handleEscChange = (event) => {
  setEscTickData((prevData) => ({
    ...prevData,
    [event.target.name]:event.target.value
  }));
};
const handleEscChangeTextarea = (event) => {
  const newValue = event.target.value;
  setEscTickData((prevData) => ({
    ...prevData,
    reply: newValue,
  }));
};
const formSubmitmed = (e) => {
  e.preventDefault();
  if (!TickData.assign_to) {
    Swal.fire('Error', 'Please select a User to Assign.', 'error');
    return;
  }
  if (!TickData.resolve_status) {
    Swal.fire('Error', 'Please select a Response Status.', 'error');
    return;
  }
      const tid = document.getElementById('tid');
      const tidValue = tid.value;
      const _formData = new FormData();
      _formData.append('ticket', tidValue);
      _formData.append('reply', TickData.reply);
      _formData.append('assign_to', TickData.assign_to);
      _formData.append('resolve_status', TickData.resolve_status);
      _formData.append('addedby', userName);
      _formData.append('ip_add', ipAddress);
      _formData.append('location', userLocation);

      axios.post(`${baseUrl}ticket-response/`, _formData)
        .then(response => {
          if(response.status==200 || response.status==201){
            const tkData = {
                open_status: TickData.resolve_status,
                ip_add: ipAddress,
              };
            axios.put(`${baseUrl}ticket-update/` + tidValue + '/', tkData)
            .then(response => {
            })
            Swal.fire({
              title: 'Tick Responded.',
              icon: 'success',
              timer: 5000,
              showConfirmButton: false
            });
            setTimeout(() => {
              window.location.href = '/ticket-response/';
            }, 3000);
          }
        })
        .catch(error => {
          console.log(error);
          Swal.fire(
            'Error!',
            'Failed to Send Response. Please try again later.',
            'error'
          );
        });
};
  const formSubmitupd = (e) => {
      e.preventDefault();
          const response = document.getElementById('response');
          const responseValue = response.value;
          const tkid = document.getElementById('tkid');
          const tkidValue = tkid.value;
          const resolve_on= selectedDate.toISOString().slice(0,10);
          const _formData = new FormData();
          _formData.append('reply', ResTickData.reply);
          _formData.append('resolve_status', ResTickData.resolve_status);
          _formData.append('resolve_on', resolve_on);
          _formData.append('addedby', userName);
          _formData.append('ip_add', ipAddress);
          _formData.append('location', userLocation);

          axios.put(`${baseUrl}response-update/` + responseValue + '/', _formData)
            .then(response => {
              if(response.status==200 || response.status==201){
                const tkData = {
                    open_status: ResTickData.resolve_status,
                    ip_add: ipAddress,
                  };
                axios.put(`${baseUrl}ticket-update/` + tkidValue + '/', tkData)
                .then(response => {
                })
                Swal.fire({
                  title: 'Tick Responded.',
                  icon: 'success',
                  timer: 5000,
                  showConfirmButton: false
                });
                setTimeout(() => {
                  window.location.href = '/ticket-response/';
                }, 3000);
              }
            })
            .catch(error => {
              console.log(error);
              Swal.fire(
                'Error!',
                'Failed to Send Response. Please try again later.',
                'error'
              );
            });
  };
const formSubmitesc = (e) => {
      e.preventDefault();
          const rid = document.getElementById('rid');
          const ridValue = rid.value;
          const etid = document.getElementById('etid');
          const etidValue = etid.value;
          const escl_on= selectedEscDate.toISOString().slice(0,10);
          const _formData = new FormData();
          _formData.append('reply', EscTickData.reply);
          _formData.append('resolve_status', EscTickData.resolve_status);
          _formData.append('resolve_on', EscTickData.resolve_on);
          _formData.append('escl_on', escl_on);
          _formData.append('escl_status', EscTickData.escl_status);
          _formData.append('escl_to', EscTickData.escl_to);
          _formData.append('escl_type', EscTickData.escl_type);
          _formData.append('escl_action', EscTickData.escl_action);
          _formData.append('addedby', userName);
          _formData.append('ip_add', ipAddress);
          _formData.append('location', userLocation);

          axios.put(`${baseUrl}response-update/` + ridValue + '/', _formData)
            .then(response => {
              if(response.status==200 || response.status==201){
                const tkData = {
                    open_status: '4',
                    ip_add: ipAddress,
                  };
                axios.put(`${baseUrl}ticket-update/` + etidValue + '/', tkData)
                .then(response => {
                })
                Swal.fire({
                  title: 'Tick Responded.',
                  icon: 'success',
                  timer: 5000,
                  showConfirmButton: false
                });
                setTimeout(() => {
                  window.location.href = '/ticket-response/';
                }, 3000);
              }
            })
            .catch(error => {
              console.log(error);
              Swal.fire(
                'Error!',
                'Failed to Send Response. Please try again later.',
                'error'
              );
            });
  };


return (
 <section className="container mt-4">
  <h3 className="text-center" style={{color: 'white', backgroundColor: '#0dcaf0'}}><i className="fa-solid fa-ticket"
        aria-hidden="true" style={{color: 'red'}}></i> View Tickets</h3>
  <div className="modal fade" id="response-modal" tabIndex="-1" aria-labelledby="response-modal-label"
   aria-hidden="true">
  <div className="modal-dialog">
    <div className="modal-content">
      <div className="modal-header">
        <h5 className="modal-title" id="response-modal-label">Ticket Response</h5>
        <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div className="modal-body">
          <form>
            <label className="form-label">Ticket ID:</label>
            <input type="hidden" className="form-control" id="tid" name="tid" value={tickRes.tid} />
            <span className="form-control">{tickRes.ticket}</span>

            <label className="form-label">Asset Name:</label>
            <span className="form-control">{tickRes.asset}</span>

            <label className="form-label">Priority:</label>
            <span className="form-control">{tickRes.priority}</span>

            <label className="form-label">Subject:</label>
            <span className="form-control">{tickRes.subject}</span>

            <label className="form-label">Reason:</label>
            <span className="form-control">{tickRes.reason}</span>

            <label className="form-label">Assign To:</label>
            <select className="form-control" value={tickRes.assign_to} onChange={handleTickChange} name="assign_to" id="assign_to">
              <option>Select</option>
              {user.map((department, index) => (
                <option key={index} value={department.username}>
                  {department.username}
                </option>
              ))}
            </select>

            <label>Response Status:</label>
            <select name="resolve_status" id="resolve_status" className="form-control" onChange={handleTickChange}>
              <option>Select Status</option>
              <option value="1">Open</option>
              <option value="2">InProgress</option>
              <option value="3">Answered</option>
              <option value="4">Reopened</option>
              <option value="5">Closed</option>
            </select>

            <label>Response:</label>
            <textarea className="form-control" id="reply" name="reply" onChange={handleTickChange}></textarea>

            <button type="button" onClick={formSubmitmed} className="btn btn-primary mt-4">
              Submit
            </button>
          </form>
      </div>
    </div>
  </div>
</div>
 <div className="modal fade" id="response-update-modal" tabIndex="-1" aria-labelledby="response-update-modal-label"
   aria-hidden="true">
  <div className="modal-dialog">
    <div className="modal-content">
      <div className="modal-header">
        <h5 className="modal-title" id="response-update-modal-label">Ticket Response</h5>
        <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div className="modal-body">
        <form>
            <label className="form-label">Ticket ID:</label>
            <input type="hidden" className="form-control" id="response" name="response" value={ResTickData.resid} />
            <input type="hidden" className="form-control" id="tkid" name="tkid" value={ResTickData.tkid} />
            <span className="form-control">{ResTickData.ticket}</span>

            <label className="form-label">Asset Name:</label>
            <span className="form-control">{ResTickData.asset}</span>

            <label className="form-label">Priority:</label>
            <span className="form-control">{ResTickData.priority}</span>

            <label className="form-label">Subject:</label>
            <span className="form-control">{ResTickData.subject}</span>

            <label className="form-label">Reason:</label>
            <span className="form-control">{ResTickData.reason}</span>

            <label>Response Status: </label>
            <select name="resolve_status" id="resolve_status" className="form-control" onChange={handleRespChange} value={ResTickData.resolve_status}>
               <option >Select Status</option>
               <option value="1">Open</option>
               <option value="2">InProgress</option>
               <option value="3">Answered</option>
               <option value="4">Reopened</option>
               <option value="5">Closed</option>
            </select>
            <label>Response: </label>
            <textarea className="form-control" id="reply" name="reply" onChange={handleRespChangeTextarea} value={ResTickData.reply}> </textarea>
            <label className="form-label">Resolved Date:</label>
            <DatePicker selected={selectedDate || new Date()} onChange={handleDateChange} dateFormat="yyyy-MM-dd" />
            <button type="button" onClick={formSubmitupd} className="btn btn-primary mt-4">
               Submit</button>
        </form>
      </div>
    </div>
  </div>
 </div>
 <div className="modal fade" id="response-esc-modal" tabIndex="-1" aria-labelledby="response-esc-modal-label"
   aria-hidden="true">
  <div className="modal-dialog">
    <div className="modal-content">
      <div className="modal-header">
        <h5 className="modal-title" id="response-esc-modal-label">Ticket Escalation</h5>
        <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div className="modal-body">
        <form>
            <label className="form-label">Ticket ID:</label>
            <input type="hidden" className="form-control" id="rid" name="rid" value={EscTickData.rid} />
            <input type="hidden" className="form-control" id="etid" name="etid" value={EscTickData.etid} />
            <span className="form-control">{EscTickData.ticket}</span>

            <label className="form-label">Asset Name:</label>
            <span className="form-control">{EscTickData.asset}</span>

            <label className="form-label">Resolved On:</label>
            <span className="form-control">{EscTickData.resolve_on}</span>

            <label className="form-label">Assign To:</label>
            <select className="form-control" onChange={handleEscChange} name="escl_to" id="escl_to" value={EscTickData.escl_to}>
              <option>Select</option>
              {user.map((department, index) => (
                <option key={index} value={department.username}>
                  {department.username}
                </option>
              ))}
            </select>

            <label>Escalate Status: </label>
            <select name="escl_status" id="escl_status" className="form-control" onChange={handleEscChange} value={EscTickData.escl_status}>
               <option >Select Status</option>
               <option value="Upgrade">Upgrade</option>
               <option value="PM">PreventiveMaintenance</option>
               <option value="Repairs">Repairs</option>
            </select>
            <label>Escalate Type: </label>
            <select name="escl_type" id="escl_type" className="form-control" onChange={handleEscChange} value={EscTickData.escl_type}>
               <option >Select Type</option>
               <option value="AMC">AMC</option>
               <option value="Repairs">Repairs</option>
               <option value="Warranty">Under Warranty</option>
            </select>
            <label>Escalate Action: </label>
            <select name="escl_action" id="escl_action" className="form-control" onChange={handleEscChange} value={EscTickData.escl_action}>
               <option >Select Type</option>
               <option value="Returnable">Returnable</option>
               <option value="NonReturnable">NonReturnable</option>
               <option value="Store-Condemnation">Store-Condemnation</option>
            </select>
            <label>Response: </label>
            <textarea className="form-control" id="reply" name="reply" onChange={handleEscChangeTextarea} value={EscTickData.reply}> </textarea>
            <label className="form-label">Estimated Resolve Date:</label>
            <DatePicker selected={selectedEscDate || new Date()} onChange={handleEscDateChange} dateFormat="yyyy-MM-dd" value={EscTickData.escl_on}/>
            <button type="button" onClick={formSubmitesc} className="btn btn-primary mt-4">
               Submit</button>
        </form>
      </div>
    </div>
  </div>
 </div>
      <div className="row mt-4">
           {!isLoading && Tickview.length > 0 ? (
            <div style={{ height: "100%", width: "100%" }}>
              <DataGrid className="mt-4"
                sx={{
                  boxShadow: 4,
                  border: 4,
                  borderColor: 'primary.light',
                  '& .MuiDataGrid-cell:hover': {
                    color: 'primary.main',
                  },
                }}
                rows={Tickview}
                columns={columns}
                pageSize={10}
                slots={{
                  toolbar: GridToolbar,
                }}
                autoHeight
              />
            </div>
          ) : (
            <></>
          )}

    </div>
    </section>
  )
}
export default TicketResponse;
